import React from "react";

const KpiCard = ({
  label,
  value,
  sub,
  icon,
  color = "green",
  onClick,
}) => {
  return (
    <div
      className={`kpi-card kpi-card--${color}`}
      onClick={onClick}
    >
      <div className="kpi-icon">
        {icon}
      </div>

      <div className="kpi-body">
        <h2 className="kpi-value">{value}</h2>

        <h4 className="kpi-label">{label}</h4>

        <p className="kpi-sub">{sub}</p>
      </div>
    </div>
  );
};

export default KpiCard;